import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class InfoBoxComponent implements OnInit {
  @Input() infoBoxText: string;
  @Input() infoBoxTitle: string;
  @Input() width: number;
  @Input() bordered = false;
  @Input() maxWidthLimited = true;
  @Input() type: 'info' | 'warning' | 'error' | 'success' = 'info';
  @Input() iconStyle: 'monochrome' | 'blue' = 'blue';
  @Input() variant: 'classic' | 'modern' = 'classic';

  content: any;
  constructor(private router: Router, private translate: TranslateService) { }

  ngOnInit() {
    this.translate.get('SHARED.INFO_BOX').subscribe({
      next: (content) => {
        this.content = content;
        if (!this.infoBoxTitle) {
          this.infoBoxTitle = this.content.WARNING;
        }
      }
    });
  }
}